import React, { useEffect } from 'react';
import Preloader from '../../components/Preloader';
import Banner from '../../components/Banner';
import Info from './Info';
import ContactForm from '../../components/ContactForm';

/**
 * Contact Page Component
 * Renders the Contact Me page with banner, info, and contact form.
 * Applies specific body classes on mount and cleans up on unmount.
 */
const ContactPage = () => {
	useEffect(() => {
		const pageClasses = ['inner-page', 'contact-me'];
		pageClasses.forEach(cls => document.body.classList.add(cls));

		return () => {
			pageClasses.forEach(cls => document.body.classList.remove(cls));
		};
	}, []);

	return (
		<>
			<Preloader />
			<Banner page={{ title: 'Contact Me' }} />
			<Info page={{ id: '179' }} />
			<ContactForm />
		</>
	);
};

export default ContactPage;
